import { type VariableValue } from "@doitintl/cmp-models/src/CloudFlowVariables";
import { TableCell, TableRow, Typography } from "@mui/material";

import { globalText } from "../../../../../assets/texts";
import { ThreeDotsMenu, type ThreeDotsMenuOption } from "../../../../../Components/ThreeDotsMenu/ThreeDotsMenu";
import { type VariableScope } from "../../../../../Pages/Cloudflow/types";

type Props = {
  item: VariableValue;
  onEdit?: (variable: VariableValue) => void;
  onDelete?: (id: string) => void;
  scope: VariableScope;
};

const VariableRow = ({ item, onEdit, onDelete, scope }: Props) => {
  const options: ThreeDotsMenuOption[] = [
    {
      label: globalText.EDIT,
      action: () => onEdit?.(item),
      key: globalText.EDIT,
    },
    {
      label: <Typography color="error">{globalText.DELETE}</Typography>,
      action: () => {
        onDelete?.(item.id);
      },
      key: globalText.DELETE,
    },
  ];

  return (
    <TableRow>
      <TableCell>
        <Typography variant="body2">{item.name}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{String(item.value)}</Typography>
      </TableCell>
      {scope === "local" && (
        <TableCell align="right">
          <ThreeDotsMenu options={options} size="small" closeAfterSelect />
        </TableCell>
      )}
    </TableRow>
  );
};

export default VariableRow;
